export enum YesOrNoEnum {
  Yes = 1,
  No = 2
}

export const YesOrNoOptions = [
{ id: 1, label: 'Yes' },
{ id: 2, label: 'No' }
];
